<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h1 class="headingtitle">Aviso Legal</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row
                class="pb--80 align-items-center text-justify"
              >
                <v-col lg="12" md="12" cols="12">
                  <!-- <div class="details mt_md--30 mt_sm--30" v-if="!NOTARIA.CIF">
                    <p >
                    {{NOTARIA.Nombre}}, dirección {{NOTARIA.Contacto.Direccion}} no puede asumir ninguna responsabilidad derivada del uso incorrecto, inapropiado o ilícito de la información aparecida en la página de Internet de {{NOTARIA.Ruta}}

                    Con los límites establecidos en la ley, {{NOTARIA.Nombre}}, no asume ninguna responsabilidad derivada de la falta de veracidad, integridad, actualización y precisión de los datos o informaciones que se contienen en sus páginas de Internet.

                    Los contenidos e información no vinculan a {{NOTARIA.Nombre}}, ni constituyen opiniones, consejos o asesoramiento legal de ningún tipo pues se trata meramente de un servicio ofrecido con carácter informativo y divulgativo.

                    La página de Internet de {{NOTARIA.Nombre}} puede contener enlaces (links) a otras páginas de terceras partes que {{NOTARIA.Nombre}}, no puede controlar. Por lo tanto, {{NOTARIA.Nombre}}, no puede asumir responsabilidades por el contenido que pueda aparecer en páginas de terceros.

                    Los textos, imágenes, sonidos, animaciones, software y el resto de contenidos incluidos en este website son propiedad exclusiva de {{NOTARIA.Nombre}}, o sus licenciantes. Cualquier acto de transmisión, distribución, cesión, reproducción, almacenamiento o comunicación pública total o parcial, debe contar con el consentimiento expreso de {{NOTARIA.Nombre}}.

                    Asimismo, para acceder a algunos de los servicios que {{NOTARIA.Nombre}}, ofrece a través del website deberá proporcionar algunos datos de carácter personal. En cumplimiento de lo establecido en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos le informamos que, mediante la cumplimentación de los presentes formularios, sus datos personales quedarán incorporados y serán tratados en los ficheros de {{NOTARIA.Nombre}}, con el fin de poderle prestar y ofrecer nuestros servicios así como para informarle de las mejoras del sitio Web. 
                    
                    Asimismo, le informamos de la posibilidad de que ejerza los derechos de acceso, rectificación, cancelación y oposición de sus datos de carácter personal, manera gratuita mediante email a web@notin.net.
                    </p>
                  </div> -->

                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="!NOTARIA.cif">
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><u><b>AVISO
LEGAL</b></u></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>0.
OBJETO Y ACEPTACI&Oacute;N</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
presente aviso legal regula el uso del sitio web </font></font></font><font color="#0070c0"><font><font size="3" style="font-size: 12pt"><b>{{NOTARIA.Ruta}}
</b></font></font></font><font ><font><font size="3" style="font-size: 12pt"> (en
adelante, LA WEB), del que es titular </font></font></font><font><font size="3" style="font-size: 12pt"><b>UNIVERSAL DATA S.L. 
</b></font></font><font ><font><font size="3" style="font-size: 12pt"> (en
adelante, EL PROPIETARIO DE LA WEB).</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">La
navegaci&oacute;n por el sitio web de EL PROPIETARIO DE LA WEB
atribuye la condici&oacute;n de usuario del mismo e implica la
aceptaci&oacute;n plena y sin reservas de todas y cada una de las
disposiciones incluidas en este Aviso Legal, que pueden sufrir
modificaciones.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
usuario se obliga a hacer un uso correcto del sitio web de
conformidad con las leyes, la buena fe, el orden p&uacute;blico, los
usos del tr&aacute;fico y el presente Aviso Legal. El usuario
responder&aacute; frente a EL PROPIETARIO DE LA WEB o frente a
terceros, de cualesquiera da&ntilde;os y perjuicios que pudieran
causarse como consecuencia del incumplimiento de dicha obligaci&oacute;n.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>1.
IDENTIFICACI&Oacute;N Y COMUNICACIONES</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">EL
PROPIETARIO DE LA WEB, en cumplimiento de la Ley 34/2002, de 11 de
julio, de servicios de la sociedad de la informaci&oacute;n y de
comercio electr&oacute;nico, le informa que:</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Identidad
del Responsable:</font></font><font><font size="3" style="font-size: 12pt">&nbsp;</font></font><font><font size="3" style="font-size: 12pt"><b>UNIVERSAL DATA S.L.</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">NIF/CIF:</font></font><font><font size="3" style="font-size: 12pt">B-30417778</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Direcci&oacute;n:</font></font><font><font size="3" style="font-size: 12pt">Calle Doctor Severo Ochoa (ed pq. Imperial) Murcia, 30107</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Para
comunicarse con nosotros, ponemos a su disposici&oacute;n diferentes
medios de contacto que detallamos a continuaci&oacute;n:</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Tfno: 968 88 27 37
</font></font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Email: <a title="Enviar email a info@unidata.es" href="mailto:info@unidata.es">info@unidata.es</a></font></font></font><font ><font><font size="3" style="font-size: 12pt">
</font></font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>2.
CONDICIONES DE ACCESO Y UTILIZACI&Oacute;N</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
usuario garantiza la autenticidad y actualidad de todos aquellos
datos que comunique a EL PROPIETARIO DE LA WEB y ser&aacute; el &uacute;nico
responsable de las manifestaciones falsas o inexactas que realice.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
usuario se compromete expresamente a hacer un uso adecuado de los
contenidos y servicios de EL PROPIETARIO DE LA WEB y a no emplearlos
para, entre otros:</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">a)
Difundir contenidos delictivos, violentos, pornogr&aacute;ficos,
racistas, xen&oacute;fobo, ofensivos, de apolog&iacute;a del
terrorismo o, en general, contrarios a la ley o al orden p&uacute;blico.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">b)
Introducir en la red virus inform&aacute;ticos o realizar actuaciones
susceptibles de alterar, estropear, interrumpir o generar errores o
da&ntilde;os en los documentos electr&oacute;nicos, datos o sistemas
f&iacute;sicos y l&oacute;gicos de EL PROPIETARIO DE LA WEB o de
terceras personas; as&iacute; como obstaculizar el acceso de otros
usuarios al sitio web y a sus servicios mediante el consumo masivo de
los recursos inform&aacute;ticos a trav&eacute;s de los cuales EL
PROPIETARIO DE LA WEB presta sus servicios.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">c)
Intentar acceder a las cuentas de correo electr&oacute;nico de otros
usuarios o a &aacute;reas restringidas de los sistemas inform&aacute;ticos
de EL PROPIETARIO DE LA WEB o de terceros y, en su caso, extraer
informaci&oacute;n.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">d)
Vulnerar los derechos de propiedad intelectual o industrial, as&iacute;
como violar la confidencialidad de la informaci&oacute;n de EL
PROPIETARIO DE LA WEB o de terceros.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">e)
Suplantar la identidad de otro usuario, de las administraciones
p&uacute;blicas o de un tercero.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">f)
Reproducir, copiar, distribuir, poner a disposici&oacute;n de, o
cualquier otra forma de comunicaci&oacute;n p&uacute;blica,
transformar o modificar los contenidos, a menos que se cuente con la
autorizaci&oacute;n del titular de los correspondientes derechos o
ello resulte legalmente permitido.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">g)
Recabar datos con finalidad publicitaria y de remitir publicidad de
cualquier clase y comunicaciones con fines de venta u otras de
naturaleza comercial sin que medie su previa solicitud o
consentimiento.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Todos
los contenidos del sitio web, como textos, fotograf&iacute;as,
gr&aacute;ficos, im&aacute;genes, iconos, tecnolog&iacute;a,
software, as&iacute; como su dise&ntilde;o gr&aacute;fico y c&oacute;digos
fuente, constituyen una obra cuya propiedad pertenece a EL
PROPIETARIO DE LA WEB, sin que puedan entenderse cedidos al usuario
ninguno de los derechos de explotaci&oacute;n sobre los mismos m&aacute;s
all&aacute; de lo estrictamente necesario para el correcto uso de la
web.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">En
definitiva, los usuarios que accedan a este sitio web pueden
visualizar los contenidos y efectuar, en su caso, copias privadas
autorizadas siempre que los elementos reproducidos no sean cedidos
posteriormente a terceros, ni se instalen a servidores conectados a
redes, ni sean objeto de ning&uacute;n tipo de explotaci&oacute;n.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Asimismo,
todas las marcas, nombres comerciales o signos distintivos de
cualquier clase que aparecen en el sitio web son propiedad de EL
PROPIETARIO DE LA WEB, sin que pueda entenderse que el uso o acceso
al mismo atribuya al usuario derecho alguno sobre los mismos.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">La
distribuci&oacute;n, modificaci&oacute;n, cesi&oacute;n o
comunicaci&oacute;n p&uacute;blica de los contenidos y cualquier otro
acto que no haya sido expresamente autorizado por el titular de los
derechos de explotaci&oacute;n quedan prohibidos.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
establecimiento de un hiperenlace no implica en ning&uacute;n caso la
existencia de relaciones entre EL PROPIETARIO DE LA WEB y el
propietario del sitio web en la que se establezca, ni la aceptaci&oacute;n
y aprobaci&oacute;n por parte de EL PROPIETARIO DE LA WEB de sus
contenidos o servicios. Aquellas personas que se propongan establecer
un hiperenlace previamente deber&aacute;n solicitar autorizaci&oacute;n
por escrito a EL PROPIETARIO DE LA WEB. En todo caso, el hiperenlace
&uacute;nicamente permitir&aacute; el acceso a la home-page o p&aacute;gina
de inicio de nuestro sitio web, asimismo deber&aacute; abstenerse de
realizar manifestaciones o indicaciones falsas, inexactas o
incorrectas sobre EL PROPIETARIO DE LA WEB, o incluir contenidos
il&iacute;citos, contrarios a las buenas costumbres y al orden
p&uacute;blico.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">EL
PROPIETARIO DE LA WEB no se responsabiliza del uso que cada usuario
le d&eacute; a los materiales puestos a disposici&oacute;n en este
sitio web ni de las actuaciones que realice en base a los mismos.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>3.
EXCLUSI&Oacute;N DE GARANT&Iacute;AS Y DE RESPONSABILIDAD</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
contenido del presente sitio web es de car&aacute;cter general y
tiene una finalidad meramente informativa, sin que se garantice
plenamente el acceso a todos los contenidos, ni su exhaustividad,
correcci&oacute;n, vigencia o actualidad, ni su idoneidad o utilidad
para un objetivo espec&iacute;fico.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">EL
PROPIETARIO DE LA WEB excluye, hasta donde permite el ordenamiento
jur&iacute;dico, cualquier responsabilidad por los da&ntilde;os y
perjuicios de toda naturaleza derivados de:</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">a)
La imposibilidad de acceso al sitio web o la falta de veracidad,
exactitud, exhaustividad y/o actualidad de los contenidos, as&iacute;
como la existencia de vicios y defectos de toda clase de los
contenidos transmitidos, difundidos, almacenados, puestos a
disposici&oacute;n, a los que se haya accedido a trav&eacute;s del
sitio web o de los servicios que se ofrecen.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">b)
La presencia de virus o de otros elementos en los contenidos que
puedan producir alteraciones en los sistemas inform&aacute;ticos,
documentos electr&oacute;nicos o datos de los usuarios.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">c)
El incumplimiento de las leyes, la buena fe, el orden p&uacute;blico,
los usos del tr&aacute;fico y el presente aviso legal como
consecuencia del uso incorrecto del sitio web. En particular, y a
modo ejemplificativo, EL PROPIETARIO DE LA WEB no se hace responsable
de las actuaciones de terceros que vulneren derechos de propiedad
intelectual e industrial, secretos empresariales, derechos al honor,
a la intimidad personal y familiar y a la propia imagen, as&iacute;
como la normativa en materia de competencia desleal y publicidad
il&iacute;cita.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Asimismo,
EL PROPIETARIO DE LA WEB declina cualquier responsabilidad respecto a
la informaci&oacute;n que se halle fuera de esta web. La funci&oacute;n
de los links que aparecen en esta web es exclusivamente la de
informar al usuario sobre la existencia de otras fuentes susceptibles
de ampliar los contenidos que ofrece este sitio web. EL PROPIETARIO
DE LA WEB no garantiza ni se responsabiliza del funcionamiento o
accesibilidad de los sitios enlazados; ni sugiere, invita o
recomienda la visita a los mismos, por lo que tampoco ser&aacute;
responsable del resultado obtenido. EL PROPIETARIO DE LA WEB no se
responsabiliza del establecimiento de hiperv&iacute;nculos por parte
de terceros.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>4.
POL&Iacute;TICA DE PRIVACIDAD</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>4.1.
&iquest;Qui&eacute;n es el Responsable de tratamiento de sus datos?</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">El
responsable de tratamiento se encuentra identificado en el expositivo
1 de este Aviso Legal.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Se
le informa que para una mayor garant&iacute;a en el cumplimiento de
la Protecci&oacute;n de datos ha sido designado a un delegado en
Protecci&oacute;n de Datos cuyos datos de contacto es el siguiente:
</font></font><a href="mailto:dpd@aequus.es"><font><font size="3" style="font-size: 12pt"><u>dpd@aequus.es</u></font></font></a><font><font size="3" style="font-size: 12pt">.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.2.
Finalidades</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Con
qu&eacute; finalidad tratamos sus datos personales? En cumplimiento
de lo dispuesto en el Reglamento Europeo 2016/679 General de
Protecci&oacute;n de Datos, te informamos que en </font></font><font><font size="3" style="font-size: 12pt">la
Notar&iacute;a</font></font><font><font size="3" style="font-size: 12pt">
</font></font><font><font size="3" style="font-size: 12pt">tratamos
los datos que nos facilite para las siguientes finalidades:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">1.-
</font></font><font><font size="3" style="font-size: 12pt">La
gesti&oacute;n de su consulta.	</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">2.-
</font></font><font><font size="3" style="font-size: 12pt">Env&iacute;o
de informaci&oacute;n, por v&iacute;a electr&oacute;nica o no
electr&oacute;nica, relacionada con su consulta y los servicios de la
notar&iacute;a. </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">3.-
</font></font><font><font size="3" style="font-size: 12pt">Servicio
de atenci&oacute;n al usuario, resoluci&oacute;n de dudas,
presentaci&oacute;n de quejas o sugerencias.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Le
recordamos que el tratamiento con las finalidades descritas es
necesario para la satisfacci&oacute;n de los intereses leg&iacute;timos
perseguidos por la Notar&iacute;a.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.3.
Tipolog&iacute;a de los datos que se tratan </b></font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
el marco de las finalidades a los que se han hecho referencia, la
Notar&iacute;a y siempre condicionado a las finalidades consentidas,
trataremos las siguientes categor&iacute;as de datos:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">-
Datos identificativos y de contacto por ejemplo a t&iacute;tulo
enunciativo, pero no limitativo: nombre, apellidos, tel&eacute;fono o
correo electr&oacute;nico.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.4.
Plazo o criterio de la conservaci&oacute;n de los datos</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Por
cu&aacute;nto tiempo conservaremos sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Sus
datos ser&aacute;n conservados mientras sean necesarios para la
prestaci&oacute;n de los servicios o en su caso mientras dure la
relaci&oacute;n entre las partes, y en cualquier caso mientras no
solicite su supresi&oacute;n, as&iacute; como el tiempo necesario
para dar cumplimiento a las obligaciones legales que en cada caso
correspondan acorde con cada tipolog&iacute;a de datos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.5.
Legitimaci&oacute;n</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Cu&aacute;l
es la legitimaci&oacute;n para el tratamiento de sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">El
tratamiento de los datos personales relacionado con el mantenimiento
de su relaci&oacute;n con la Notar&iacute;a est&aacute; legitimado al
resultar necesario para dar cumplimiento a las obligaciones
contractuales derivadas de dicha relaci&oacute;n. </font></font><font><font size="3" style="font-size: 12pt">El
tratamiento de sus datos personales vinculados a dichos fines es
estrictamente necesario para dar cumplimiento a las mencionadas
obligaciones legales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.6.
Destinatario</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;A
qu&eacute; destinatarios se comunicar&aacute;n sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Con
car&aacute;cter general no se ceder&aacute;n datos a terceros salvo
obligaci&oacute;n legal.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">No
obstante, sus datos podr&aacute;n ser cedidos a los destinatarios que
se indican a continuaci&oacute;n, por los motivos que se explican</font></font><font><font size="3" style="font-size: 12pt">
y en todo caso por ser necesaria dichas comunicaciones para las
finalidades derivadas de la relaci&oacute;n entre las partes</font></font><font><font size="3" style="font-size: 12pt">:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Administraciones
P&uacute;blicas: para el cumplimiento de las obligaciones legales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Proveedores
que precisen acceder a sus datos para la prestaci&oacute;n de
servicios que la Notar&iacute;a haya contratado a dichos proveedores,
y con los cuales la Notar&iacute;a tiene suscritos los contratos de
confidencialidad y de tratamiento de datos personales necesarios y
exigidos por la normativa para proteger su privacidad.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; page-break-after: avoid">
<font><font size="3" style="font-size: 12pt">Le
recordamos que desde la Notar&iacute;a no se realizan transferencias
internacionales de datos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; background: #ffffff">
<font><font size="3" style="font-size: 12pt">Durante
el tratamiento de datos del usuario, es posible que utilicemos
software cuya procedencia o servidores est&eacute;n ubicados fuera
del Espacio Econ&oacute;mico Europeo, en particular, en pa&iacute;ses
que ofrezcan un nivel adecuado de protecci&oacute;n o en EEUU. En
esos casos, nos aseguraremos que trabajamos con proveedores que
garantizan el cumplimiento de los est&aacute;ndares y normativas
europeas en materia de protecci&oacute;n de datos aplicables, y en
particular, el RGPD (Reglamento General de Protecci&oacute;n de Datos
UE 679/2016). Las transferencias de datos a EEUU estar&aacute;n
siempre amparadas en el Escudo de Privacidad EU &ndash; EEUU. Puede
consultar m&aacute;s informaci&oacute;n en&nbsp;</font></font><a href="http://www.techoscalabuig.com/www.privacyshield.org" target="_blank"><font><font size="3" style="font-size: 12pt"><u>www.privacyshield.org</u></font></font></a><font><font size="3" style="font-size: 12pt">.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.7.
Derechos</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Cu&aacute;les
son sus derechos cuando nos facilita sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Tiene
derecho a obtener confirmaci&oacute;n sobre si estamos tratando datos
personales que le conciernan, o no.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Asimismo,
tiene derecho a acceder a sus datos personales, as&iacute; como a
solicitar la rectificaci&oacute;n de los datos inexactos o, en su
caso, solicitar su supresi&oacute;n cuando, entre otros motivos, los
datos ya no sea necesarios para los fines que fueron recogidos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
determinadas circunstancias, podr&aacute; solicitar la limitaci&oacute;n
del tratamiento de sus datos, en cuyo caso &uacute;nicamente los
conservaremos para el ejercicio o la defensa de reclamaciones.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
determinadas circunstancias y por motivos relacionados con tu
situaci&oacute;n particular, podr&aacute; oponerse al tratamiento de
sus datos. </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Asimismo,
puede ejercer el derecho a la portabilidad de los datos, as&iacute;
como retirar los consentimientos facilitados en cualquier momento,
sin que ello afecte a la licitud del tratamiento basado en el
consentimiento previo a su retirada.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Podr&aacute;
ejercer dichos derechos mediante petici&oacute;n escrita dirigida
enviando un correo electr&oacute;nico a </font></font><font><font size="3" style="font-size: 12pt">________________@</font></font><font><font size="3" style="font-size: 12pt">__________</font></font><font><font size="3" style="font-size: 12pt">,
adjuntando una copia de su DNI u otro documento que acredite su
identidad, e indicando claramente el derecho que quiere ejercer.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Por
&uacute;ltimo, le informamos que puede dirigirse ante la Agencia
Espa&ntilde;ola de Protecci&oacute;n de Datos y dem&aacute;s
organismos p&uacute;blicos competentes para cualquier reclamaci&oacute;n
derivada del tratamiento de sus datos personales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.8.
Procedencia</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;C&oacute;mo
hemos obtenido sus datos? </font></font><font><font size="3" style="font-size: 12pt"><span style="background: #ffffff">Los
datos personales son obtenidos a trav&eacute;s de la web,
directamente del usuario.</span></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; background: #ffffff">
<font><font size="3" style="font-size: 12pt">Para
una m&aacute;s informaci&oacute;n sobre la protecci&oacute;n de datos
personales le invitamos a consultar la p&aacute;gina web de la AEPD
(Agencia Espa&ntilde;ola de Protecci&oacute;n de
Datos)&nbsp;</font></font><a href="https://www.agpd.es/" target="_blank"><font><font size="3" style="font-size: 12pt"><u>https://www.agpd.es/</u></font></font></a></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>5.
PROCEDIMIENTO EN CASO DE REALIZACI&Oacute;N DE ACTIVIDADES DE
CAR&Aacute;CTER IL&Iacute;CITO</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">En
el caso de que cualquier usuario o un tercero considere que existen
hechos o circunstancias que revelen el car&aacute;cter il&iacute;cito
de la utilizaci&oacute;n de cualquier contenido y/o de la realizaci&oacute;n
de cualquier actividad en las p&aacute;ginas web incluidas o
accesibles a trav&eacute;s del sitio web, deber&aacute; enviar una
notificaci&oacute;n a EL PROPIETARIO DE LA WEB identific&aacute;ndose
debidamente, especificando las supuestas infracciones y declarando
expresamente y bajo su responsabilidad que la informaci&oacute;n
proporcionada en la notificaci&oacute;n es exacta.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">Para
toda cuesti&oacute;n litigiosa que incumba al sitio web de EL
PROPIETARIO DE LA WEB, ser&aacute; de aplicaci&oacute;n la
legislaci&oacute;n espa&ntilde;ola.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>6.
PUBLICACIONES</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt">La
informaci&oacute;n administrativa facilitada a trav&eacute;s del
sitio web no sustituye la publicidad legal de las leyes, normativas,
planes, disposiciones generales y actos que tengan que ser publicados
formalmente a los diarios oficiales de las administraciones p&uacute;blicas,
que constituyen el &uacute;nico instrumento que da fe de su
autenticidad y contenido. La informaci&oacute;n disponible en este
sitio web debe entenderse como una gu&iacute;a sin prop&oacute;sito
de validez legal.</font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 0.25in; margin-top: 0.08in; margin-bottom: 0.08in">
<br/>
<br/>

</p>



                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore();
const { NOTARIA } = storeToRefs(store)
</script>
